<template>
  <div>
    <div class="d-flex justify-content-end">
      <a
        href="#"
        v-if="hasCurrentUserPermissionAccess('patients', 'create')"
        style="font-size: 14px"
        @click.prevent="$emit('onEdit', 0)"
      >
        Edit
      </a>
    </div>
    <div
      class="profile-photo mb-2"
      :class="eoc.patient.avatarId ? 'avatar' : ''"
      @click="viewFullImage"
    >
      <img :src="avatar" />
    </div>
    <div class="d-flex flex-column align-items-center mb-2">
      <h3 style="font-size: 20px">{{ eoc.patient | formatClient }}</h3>
      <span class="h5" style="font-size: 14px">
        MR#: {{ { mrn: eoc.patient.mrn, eocn: eoc.eocn } | formatMrn }}
      </span>
      <span v-if="eoc.bed" class="h5" style="font-size: 14px">
        Room: {{ eoc.bed.room.name }} / Bed: {{ eoc.bed.name }}
      </span>
    </div>
    <div class="d-flex flex-row justify-content-center flex-wrap">
      <div v-for="badge in eoc.badges" :key="badge.id" class="mr-2 mb-2">
        <div
          class="badge badge-pill"
          style="min-width: 70px"
          :style="{ backgroundColor: badge.category.color }"
          :id="'badge-tooltip-view-' + badge.id"
        >
          <span class="h6 text-white">{{ badge.acronym }}</span>
          <b-tooltip
            :target="'badge-tooltip-view-' + badge.id"
            triggers="hover"
          >
            <small style="word-break: keep-all">{{ badge.name }}</small>
          </b-tooltip>
        </div>
      </div>
    </div>
    <hr class="mb-3" style="border-color: rgba(0, 0, 0, 0.05)" />
    <div style="font-size: 14px;">
      <div class="mb-2">
        <span>
          <strong>SSN: </strong>
          <span style="word-break: break-all;">
            {{ ssn | VMask(ssnMask) }}
          </span>
        </span>
        <a
          href="#"
          v-if="hasCurrentUserPermissionAccess('patients', 'ssn') && ssn"
          @click.prevent="showHideSSn"
          class="text-primary ml-2 show-hide-ssn"
        >
          {{ ssn.includes("*") ? "Show" : "Hide" }}
        </a>
      </div>
      <div class="mb-2">
        <span>
          <strong>Legal Sex: </strong>
          <span style="word-break: break-all;">
            {{ eoc.patient.gender ? eoc.patient.gender.name : "" }}
          </span></span
        >
      </div>
      <div class="mb-2">
        <span>
          <strong>Preferred Pronouns: </strong>
          <span style="word-break: break-all;">
            {{ eoc.patient.pronoun ? eoc.patient.pronoun.name : "" }}
          </span></span
        >
      </div>
      <div class="mb-2">
        <span>
          <strong>Email: </strong>
          <span style="word-break: break-all;">{{
            eoc.patient.email
          }}</span></span
        >
      </div>
      <div class="mb-2">
        <span>
          <strong>Address: </strong>
          <span style="word-break: break-all;">
            {{
              (eoc.patient.addressLine1 || eoc.patient.addressLine2
                ? (eoc.patient.addressLine1 ? eoc.patient.addressLine1 : "") +
                  " " +
                  (eoc.patient.addressLine2 ? eoc.patient.addressLine2 : "") +
                  ", "
                : "") +
                (eoc.patient.city ? eoc.patient.city + ", " : "") +
                (eoc.patient.state ? eoc.patient.state.name + ", " : "") +
                (eoc.patient.zipcode ? eoc.patient.zipcode : "")
            }}
          </span></span
        >
      </div>
      <div class="mb-2">
        <span>
          <strong>Marital Status: </strong>
          <span style="word-break: break-all;">
            {{
              eoc.patient.maritalStatus ? eoc.patient.maritalStatus.name : ""
            }}
          </span></span
        >
      </div>
      <div class="mb-2">
        <span>
          <strong>Mobile Phone: </strong>
          <span style="word-break: break-all;">
            {{ eoc.patient.phone }}
          </span></span
        >
      </div>
      <div class="mb-2">
        <span>
          <strong>Other Phone: </strong>
          <span style="word-break: break-all;">
            {{ eoc.patient.landLineNumber }}
          </span></span
        >
      </div>
      <div class="mb-2">
        <span>
          <strong>Preferred contact: </strong>
          <span style="word-break: break-all;">
            {{
              eoc.patient.contactPreference ? eoc.patient.contactPreference : ""
            }}
          </span></span
        >
      </div>
      <div class="mb-2">
        <span>
          <strong>Occupation: </strong>
          <span style="word-break: break-all;">
            {{ eoc.patient.occupation }}
          </span>
        </span>
      </div>
      <div class="mb-2">
        <span>
          <strong>Race: </strong>
          <span style="word-break: break-all;">
            {{ eoc.patient.race ? eoc.patient.race.name : "" }}
          </span>
        </span>
      </div>
      <div class="mb-2">
        <span>
          <strong>Ethnicity: </strong>
          <span style="word-break: break-all;">
            {{ eoc.patient.ethnicity ? eoc.patient.ethnicity.name : "" }}
          </span>
        </span>
      </div>
      <div class="mb-2">
        <span>
          <strong>Language: </strong>
          <span style="word-break: break-all;">
            {{ eoc.patient.language ? eoc.patient.language.name : "" }}
          </span>
        </span>
      </div>
      <div class="mb-2">
        <span>
          <strong>General Notes: </strong>
          <span style="word-break: break-all;">
            {{ eoc.patient ? eoc.patient.generalNotes : "" }}
          </span>
        </span>
      </div>
      <div
        class="mb-2"
        v-for="(additionalsReportResult,
        additionalsReportResultIndex) in Object.keys(
          eoc.additionalsReportResults
        )"
        :key="additionalsReportResultIndex"
      >
        <span>
          <strong>{{ additionalsReportResult }}: </strong>
          <span>
            {{ eoc.additionalsReportResults[additionalsReportResult] }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import avatarServer from "../../server/avatar";
import serverCore from "../../server/core";

export default {
  name: "EocViewSummaryDemographics",
  props: ["eoc", "showing"],
  data() {
    return {
      avatar: "",
      applyMask: false
    };
  },
  mounted() {
    this.loadAvatar();
  },
  methods: {
    async loadAvatar() {
      this.eoc.patient.contactPreference =
        this.eoc.patient.contactPreference === "Cellphone"
          ? "Mobile Phone"
          : this.eoc.patient.contactPreference === "Landline"
          ? "Other Phone"
          : "Both";
      try {
        if (this.eoc.patient.avatarId) {
          this.avatar = await avatarServer.downloadUrl(
            this.eoc.patient.avatarId
          );
        } else {
          this.avatar = require(`../../assets/avatar-example.png`);
        }
      } catch {
        this.avatar = require(`../../assets/avatar-example.png`);
      }
    },
    async showHideSSn() {
      this.applyMask = !this.applyMask;
    },
    viewFullImage() {
      if (!this.eoc.patient.avatarId) {
        return;
      }

      const viewUrl = this.$router.resolve(
        `/view-original-avatar/${serverCore.getToken()}/${
          this.eoc.patient.originalAvatarId
        }`
      );
      window.open(viewUrl.href, "_blank");
    }
  },
  computed: {
    ...mapGetters("layout", ["hasCurrentUserPermissionAccess"]),
    patientAvatar() {
      return this.eoc.patient.avatar
        ? this.eoc.patient.avatar
        : require(`../../assets/avatar-example.png`);
    },
    ssnMask() {
      return this.ssn.includes("*") ? "***-**-####" : "###-##-####";
    },
    hasAdditionalInfomation() {
      return this.eoc && this.eoc.additionalsReportResults
        ? Object.keys(this.eoc.additionalsReportResults).filter(
            additionalsReportResultIndex =>
              this.eoc.additionalsReportResults[additionalsReportResultIndex]
          ).length > 0
        : false;
    },
    ssn() {
      return !this.applyMask
        ? this.eoc.patient.ssn
        : this.eoc.patient.ssnUnmasked;
    }
  },
  watch: {
    eoc(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadAvatar();
      }
    }
  }
};
</script>

<style scoped>
.profile-photo {
  position: relative;
  max-width: 175px;
  margin: 0 auto;
}
.profile-photo img {
  width: 100%;
  height: 100%;
  border: 1px solid transparent;
  border-radius: 50%;
}

.profile-photo.avatar::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  transition: opacity 300ms;
  background: #ccc url("../../assets/icons/loupe.svg") no-repeat center;
  background-size: 25%;
  border-radius: 50%;
  cursor: pointer;
}

.profile-photo.avatar:hover img {
  border-color: #4044e6;
}

.profile-photo.avatar:hover::after {
  opacity: 0.75;
}
</style>
